import { render, staticRenderFns } from "./PhoDatePicker.vue?vue&type=template&id=35225e8c&lang=pug"
import script from "./PhoDatePicker.vue?vue&type=script&lang=js"
export * from "./PhoDatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports